/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerUserService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;
   saasApi: string = environment.saasWebAPI;

   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 产品设置接口


  /**
   * 查询产品列表
   * @param param
   * @returns {Observable<any>}
   */
  getCustomerUserList(param) {
    const url = this.prefix + 'customerUser/queryPageList';
    return this.http.Post(url, param);
  }

      /**
   * 查询邀请记录
   * @param param
   * @returns {Observable<any>}
   */
       authInviteQueryPageList(param) {
        const url = this.saasApi + 'authInvite/queryPageList';
        return this.http.Post(url, param);
      }
  //#endregion

}
